import { createSlice } from '@reduxjs/toolkit';

import { createSliceHook, makeActionCreator } from '../helpers';
import { toggleFilterState } from './toggleFilterState';
import {
  ClinicalTrialFiltersSetSearchAction,
  ClinicalTrialFiltersState,
  ClinicalTrialFiltersToggleActiveFiltersAction,
  ClinicalTrialFiltersToggleSelectedFiltersAction,
} from '@restore/clinicalTrialFilters/clinicalTrialFilters.types';

const initialState: ClinicalTrialFiltersState = {
  error: undefined,
  selectedFilters: {
    sponsor: [],
    status: [],
  },
  allFilters: {
    sponsor: [],
    status: [],
  },
  state: {
    sponsor: { active: false, label: 'Sponsor' },
    status: { active: false, label: 'Status' },
  },
  search: '',
};

const { act } = makeActionCreator<ClinicalTrialFiltersState>();

export const clinicalTrialFiltersSlice = createSlice({
  name: 'clinicalTrialFilters',
  initialState,
  reducers: {
    toggleActiveFilters: (
      filterSliceState,
      action: ClinicalTrialFiltersToggleActiveFiltersAction
    ) => toggleFilterState(filterSliceState, action.payload),
    toggleSelectedFilters: act<
      ClinicalTrialFiltersToggleSelectedFiltersAction['payload']
    >(({ name, value }, { selectedFilters }) => ({
      selectedFilters: {
        ...selectedFilters,
        [name]: selectedFilters[name]?.includes(value) ? [] : [value],
      },
    })),
    setSearch: (state, action: ClinicalTrialFiltersSetSearchAction) => {
      state.search = action.payload;
    },
    reset: () => {
      return initialState;
    },
  },
});

export const { toggleActiveFilters, toggleSelectedFilters, reset, setSearch } =
  clinicalTrialFiltersSlice.actions;

export const actions = {
  ...clinicalTrialFiltersSlice.actions,
};

export const useClinicalTrialFiltersSlice = createSliceHook(
  clinicalTrialFiltersSlice.name,
  clinicalTrialFiltersSlice.actions
);

/* eslint-disable @typescript-eslint/no-explicit-any */
export const selectClinicalTrialFiltersState = (root: any) =>
  root.clinicalTrialFilters;
